/**
 * crossNav.js — Cross-navigation utility for deep-linking between entities
 *
 * Provides navigation functions that encode entity IDs into URL search params.
 * Page components read these params and auto-select the entity.
 *
 * Pattern:
 *   navigateToJob(navigate, jobId)  →  /jobs?select=<jobId>
 *   navigateToContact(navigate, contactId) → /people?select=<contactId>
 *   navigateToInvoice(navigate, invoiceId) → /invoices?select=<invoiceId>
 *   navigateToQuote(navigate, quoteId) → /quotes?tab=browser&select=<quoteId>
 *
 * Pages keep ?select= until their list has loaded (JobsPage pattern), so a link
 * opened cold (email, calendar, a phone with no Ctrl+K cache) still lands on it.
 */

// ── Navigation functions ─────────────────────────────────────────────────────

/**
 * Navigate to a specific job
 */
export function navigateToJob(navigate, jobId) {
  navigate(`/jobs?select=${jobId}`);
}

/**
 * Navigate to a specific contact
 */
export function navigateToContact(navigate, contactId) {
  navigate(`/people?select=${contactId}`);
}

/**
 * Navigate to a specific invoice
 */
export function navigateToInvoice(navigate, invoiceId) {
  navigate(`/invoices?select=${invoiceId}`);
}

/**
 * Navigate to one quote in Saved Quotes (read-only view, never the builder:
 * opening the builder by id replaces any unsaved draft there).
 */
export function navigateToQuote(navigate, quoteId) {
  navigate(`/quotes?tab=browser&select=${quoteId}`);
}

/**
 * Navigate to quotes page
 */
export function navigateToQuotes(navigate) {
  navigate('/quotes');
}
